var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FilespaceStatus } from '@lucidlink/dto/validation';
import { Box, HardDriveIcon, translate } from '@lucidlink/uicore';
import { FilespaceListItemBase, StatusErrorIcon, StatusInProgressIcon, useFilespaceById, } from '@lucidlink/workspacemanagement';
import { FilespaceMenu } from '../menus';
import { RestrictedFilespaceListItem } from './components';
export const FilespaceListItem = ({ filespace: filespaceDataFromList, }) => {
    _react_refresh_temp_2();
    const { query: { data: filespaceData, isError: isErrorFilespace }, } = useFilespaceById(filespaceDataFromList.workspaceId, filespaceDataFromList.id);
    const filespace = !filespaceData || isErrorFilespace
        ? filespaceDataFromList
        : filespaceData;
    const filespaceStatus = filespace.status;
    let iconTooltipContent;
    if (filespaceStatus === FilespaceStatus.SETUP_ERROR) {
        iconTooltipContent = [translate('Filespace setup operation failed')];
    }
    else if (filespaceStatus === FilespaceStatus.SUSPEND_ERROR) {
        iconTooltipContent = [translate('Filespace suspend operation failed')];
    }
    else if (filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
        iconTooltipContent = [
            translate('Filespace unsuspend operation failed'),
        ];
    }
    else {
        iconTooltipContent = null;
    }
    const menuContent = (_jsx(Box, { gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", children: _jsx(FilespaceMenu, { filespace: filespace }) }));
    let StatusIcon;
    if (filespaceStatus === FilespaceStatus.SETUP_IN_PROGRESS ||
        filespaceStatus === FilespaceStatus.SUSPEND_IN_PROGRESS ||
        filespaceStatus === FilespaceStatus.UNSUSPEND_IN_PROGRESS) {
        StatusIcon = StatusInProgressIcon;
    }
    else if (filespaceStatus === FilespaceStatus.ERRORED ||
        filespaceStatus === FilespaceStatus.SETUP_ERROR ||
        filespaceStatus === FilespaceStatus.SUSPEND_ERROR ||
        filespaceStatus === FilespaceStatus.UNSUSPEND_ERROR) {
        StatusIcon = StatusErrorIcon;
    }
    else {
        StatusIcon = undefined;
    }
    if (filespace.settings.restrictWebAccess) {
        return (_jsx(RestrictedFilespaceListItem, { filespaceId: filespace.id, filespaceName: filespace.name, workspaceId: filespace.workspaceId }));
    }
    return (_jsx(_Fragment, { children: _jsx(FilespaceListItemBase, { filespace: filespace, iconTooltipContent: iconTooltipContent, LeadingIcon: _jsx(HardDriveIcon, { size: "small" }), menuContent: menuContent, StatusIcon: StatusIcon, to: `/workspaces/${filespace.workspaceId}/filespaces/${filespace.id}/dashboard` }) }));
};
_react_refresh_temp_1 = FilespaceListItem;
$RefreshReg$(_react_refresh_temp_1, "FilespaceListItem");
_react_refresh_temp_2(FilespaceListItem, "P/2kEycGTS1rkyZoNYcrVKWrO/A=", false, () => [useFilespaceById]);
